import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import { Modal } from './Modal';

import { Icon } from '@iconify/react';
import iconCheck from '@iconify-icons/mdi/check';

const ModalSuccessfulAction = (props) => {
  const propIsImage = props.title.startsWith("http")
  return (
    <Modal isOpen={props.isOpen} onClickOverlay={props.onClickOverlay} text={props.text} shouldScroll={false}>
      <div className="modal-successful-action">
        {propIsImage ?
          (
            <div className='modal-successful-action--image-frame'>
              <img src={props.title} />
            </div>
          )
          : (
            <>
              <Icon icon={iconCheck} className={cn('modal-successful-action__check')} />
              <h4 className={'modal-successful-action__title'}>{props.title}</h4>
            </>)
        }
        <p className={`modal-successful-action__text ${propIsImage ? 'no-border-top' : ''}`}>{props.text}</p>

        {propIsImage ? (
          <button className={'btn btn--primary'}>
            <a style={{ textDecoration: 'none', color: 'white' }} href={window.freedomeConfig.knownPages.catalogue}>Scopri le attività</a>
          </button>
        ) : (
          <button className={'btn'} onClick={props.onClickButton}>
            {app_main_wpml.close}
          </button>
        )}
      </div>
    </Modal>
  );
};

ModalSuccessfulAction.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClickButton: PropTypes.func.isRequired,
  onClickOverlay: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
    .isRequired,
};

export { ModalSuccessfulAction };
